import { useGetClaimHistory } from 'api/resource';
import { Debit, Provider, Status, Tariff } from 'interfaces';
import { MRT_Row } from 'mantine-react-table';
import { ClaimTimeline } from 'pages/claims/components';

export interface StatementDetailPanelProps {
  row: MRT_Row<Debit>;
  providers: Provider[];
  statuses: Status[];
  tariffs: Tariff[];
}

export const DebitDetailPanel = ({
  row,
  providers,
  statuses,
}: StatementDetailPanelProps) => {
  const {
    data: histories = [],
    isLoading: loadingHistory,
    error: claimErrorMessage,
  } = useGetClaimHistory({
    claimID: row.original?.claim?.id,
  });
  return (
    <ClaimTimeline
      data={histories}
      errorMessage={claimErrorMessage?.message}
      isError={!!claimErrorMessage}
      isLoading={loadingHistory}
      providers={providers}
      status={statuses}
    />
  );
};
